import * as Yup from "yup";
import { StringValidation } from "./PlanSchema";

export const CompanySchema = Yup.object().shape({
  name: StringValidation.label("Name"),
});
